import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=a972ca62&scoped=true"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"
import style0 from "./Charts.vue?vue&type=style&index=0&id=a972ca62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a972ca62",
  null
  
)

export default component.exports